import { default as store } from "../../store";
import { HttpClient } from "../../utilities";
import { IFolderService } from "../../domain/folder";
import { Authenticate } from "../../domain/authentication";

export class FolderService implements IFolderService {

  async authenticate(guid: string, password: string, reCaptchaResponse: string): Promise<number> {
    try {
      // TODO: recaptcha対応.
      const client = new HttpClient();
      const result = await client.post(
        "/api/folder/" + guid + "/auth",
        {
          password,
          reCaptchaResponse,
        });
      const data = result.data as Authenticate;
      if (data.errorCode === 0) {
        this.updateStore(data, guid);
      }
      return data.errorCode;
    } catch (e) {
      this.clearStore();
      throw e;
    }
  }

  private updateStore(source: Authenticate, guid: string): void {
    store.commit("setToken", source.token);
    console.debug(store.getters.token);
    store.commit("setUser", "");
    console.debug(store.getters.user);
    store.commit("setFolderGuid", guid);
    console.debug(store.getters.folderGuid);
  }

  private clearStore(): void {
    store.commit("setToken", null);
  }
}
